import * as React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';

function Copyright(props) {

    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Fulfillment Policy Order Processing -            Order Processing Time -             Pre-Orders: The processing time for pre-orders is specified prior to purchase. Materials are ordered upon receiving a pre-order, and once the materials arrive, the product is assembled and shipped.            In-Stock Items: Orders for in-stock items are processed and shipped the same day.            Order Confirmation            Once an order is placed, customers will receive an email with a tracking link. This link allows customers to track their order every step of the way.            Shipping            Shipping Methods            We offer a flat-rate shipping method.            Shipping Providers            All orders are shipped via USPS.            Shipping Times            Domestic (USA): Estimated shipping time is 4 days.            International: Estimated shipping time is 15+ days.            Shipping Costs            Domestic (USA): Flat rate of $8.            International: Flat rate of $40.            Shipping Areas            We ship worldwide.            Handling            There is no additional handling time beyond order processing and shipping.            Tracking            Customers will receive tracking information via email or direct message on Facebook.            Special Cases            Pre-Orders            For pre-orders, materials are ordered upon receiving the order. Once the materials are received, we begin assembly and any other required processes. The product is then shipped out.            Backorders            If an item is out of stock and an order is placed, the customer will be refunded.            Issues and Delays            Lost or Damaged Packages            We are not responsible for any damages that occur during shipping.            Shipping Delays            Once an item is shipped, customers will receive a tracking number. If there is a delay with the shipment, customers should contact the shipping provider directly. Once the item is out of our hands, we are unable to influence the shipment process.            Customer Support For any issues related to orders, customers can contact us via email at support@cherrypine.net.'}
            {' '}

            {' '}
        </Typography>
    );
}

// TODO remove, this demo shouldn't need to reset the theme.
let defaultTheme = createTheme({
    palette: {
        mode: 'dark',
    },
});

export default function Fullfilment() {

    return (
        <ThemeProvider theme={defaultTheme}>
            <Container component="main" maxWidth="xs">
                <CssBaseline />
                <Box
                    sx={{
                        marginTop: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                </Box>
                <Copyright sx={{ mt: 8, mb: 4 }} />
            </Container>
        </ThemeProvider>
    );
}